export { FixedTipStrategy } from './fixed-tip.strategy';
export { PercentageTipStrategy } from './percentage-tip.strategy';
